import React from 'react'

import {
  Col,
  Row,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled
} from 'components'
import { GrupoIten } from 'services/NGT/ReportsEffectives'
import { COLORS } from 'utils'
import FormatarNumeros from 'utils/formatNumbers'

// import { Container } from './styles';
interface ITableContract {
  tableData: GrupoIten[]
}
const TableContract: React.FC<ITableContract> = ({ tableData }) => {
  const index = tableData?.map((data) => data.grupo)?.indexOf('SubTotal')

  return (
    <TableContainerStyled>
      <TableStyled>
        <TableHeadStyled>
          <TableRowStyled>
            <TableCellStyled>Mês/Ano</TableCellStyled>
            <TableCellStyled align='left'>Progresso do fornecedor</TableCellStyled>
            <TableCellStyled align="left">Status Movimentação</TableCellStyled>
            <TableCellStyled align="left">Ativo</TableCellStyled>
            <TableCellStyled align="left">Demitido</TableCellStyled>
            <TableCellStyled align="left">Acesso</TableCellStyled>
            <TableCellStyled align="left">Transferido</TableCellStyled>
            <TableCellStyled align="left">Afastado</TableCellStyled>
            <TableCellStyled align="left">Compartilhado</TableCellStyled>
            <TableCellStyled align="left">Total</TableCellStyled>
            <TableCellStyled align="left">Sem Demitidos</TableCellStyled>
          </TableRowStyled>
        </TableHeadStyled>
        <TableBodyStyled>
          {tableData?.map(
            (row) =>
              !row.grupo && (
                <TableRowStyled>
                  <TableCellStyled>{row?.competencia}</TableCellStyled>
                  <TableCellStyled style={{ paddingLeft: `1.6%` }}>{row?.progressoMovimentacao}</TableCellStyled>
                  <TableCellStyled style={{ paddingLeft: `0.8%` }}>{row?.flStatusMobilizacao}</TableCellStyled>
                  <TableCellStyled style={{ paddingLeft: `${calcPadding(1.5, row?.qtAtivo)}%` }}>{formatarNumero(row?.qtAtivo)}</TableCellStyled>
                  <TableCellStyled style={{ paddingLeft: `${calcPadding(2, row?.qtDemitido)}%` }}>{formatarNumero(row?.qtDemitido)}</TableCellStyled>
                  <TableCellStyled style={{ paddingLeft: `${calcPadding(2, row?.qtAcesso)}%` }}>{formatarNumero(row?.qtAcesso)}</TableCellStyled>
                  <TableCellStyled style={{ paddingLeft: `${calcPadding(2.5, row?.qtTransferido)}%` }}>{formatarNumero(row?.qtTransferido)}</TableCellStyled>
                  <TableCellStyled style={{ paddingLeft: `${calcPadding(2.4, row?.qtAfastado)}%` }}>{formatarNumero(row?.qtAfastado)}</TableCellStyled>
                  <TableCellStyled style={{ paddingLeft: `${calcPadding(3.5, row?.qtCompartilhado)}%` }}>{formatarNumero(row?.qtCompartilhado)}</TableCellStyled>
                  <TableCellStyled style={{ paddingLeft: `${calcPadding(1.5, row?.qtTotalEfetivoComDemitido)}%` }}>{formatarNumero(row?.qtTotalEfetivoComDemitido)}</TableCellStyled>
                  <TableCellStyled style={{ paddingLeft: `${calcPadding(3, row?.qtTotalEfetivoSemDemitido)}%` }}>{formatarNumero(row?.qtTotalEfetivoSemDemitido)}</TableCellStyled>
                </TableRowStyled>
              )
          )}
          <TableRowStyled style={{ background: COLORS.lightGray }}>
            <TableCellStyled>Total</TableCellStyled>
            <TableCellStyled></TableCellStyled>
            <TableCellStyled></TableCellStyled>
            <TableCellStyled style={{ paddingLeft: `${calcPadding(1.5, tableData[index]?.qtAtivo)}%` }}>{formatarNumero(tableData[index]?.qtAtivo)}</TableCellStyled>
            <TableCellStyled style={{ paddingLeft: `${calcPadding(2, tableData[index]?.qtDemitido)}%` }}>{formatarNumero(tableData[index]?.qtDemitido)}</TableCellStyled>
            <TableCellStyled style={{ paddingLeft: `${calcPadding(2, tableData[index]?.qtAcesso)}%` }}>{formatarNumero(tableData[index]?.qtAcesso)}</TableCellStyled>
            <TableCellStyled style={{ paddingLeft: `${calcPadding(2.5, tableData[index]?.qtTransferido)}%` }}>{formatarNumero(tableData[index]?.qtTransferido)}</TableCellStyled>
            <TableCellStyled style={{ paddingLeft: `${calcPadding(2.4, tableData[index]?.qtAfastado)}%` }}>{formatarNumero(tableData[index]?.qtAfastado)}</TableCellStyled>
            <TableCellStyled style={{ paddingLeft: `${calcPadding(3.5, tableData[index]?.qtCompartilhado)}%` }}>{formatarNumero(tableData[index]?.qtCompartilhado)}</TableCellStyled>
            <TableCellStyled style={{ paddingLeft: `${calcPadding(1.5, tableData[index]?.qtTotalEfetivoComDemitido)}%` }}>{formatarNumero(tableData[index]?.qtTotalEfetivoComDemitido)}</TableCellStyled>
            <TableCellStyled style={{ paddingLeft: `${calcPadding(3, tableData[index]?.qtTotalEfetivoSemDemitido)}%` }}>{formatarNumero(tableData[index]?.qtTotalEfetivoSemDemitido)}</TableCellStyled>
          </TableRowStyled>
        </TableBodyStyled>
      </TableStyled>
    </TableContainerStyled>
  )
}

function formatarNumero(numero: number) {
  return FormatarNumeros.formatarNumero(numero) as unknown as number;
}

function calcPadding(actualPadding, itemsAmount) {
  let padding = actualPadding;
  if (itemsAmount >= 10) padding = actualPadding - 0.2;
  if (itemsAmount >= 100) padding = actualPadding - 0.4;
  if (itemsAmount >= 1000) padding = actualPadding - 0.7;
  if (itemsAmount >= 10000) padding = actualPadding - 1;

  if (padding < 0) return 0;

  return padding;
}

export default TableContract
